<template>
  <div>
    <user-list-add-new :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive" :role-options="roleOptions"
      :plan-options="planOptions" @refetch-data="refetchData" />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0" v-if="surveyInfo != null && surveyInfo != undefined">
      <div class="m-2">
        <!-- Table Top -->
        <h2>
          {{ itemtitle }}
        </h2>
        <b-row>
          <!-- Per Page -->
          <b-col cols="4" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t("survey.surveyattendee.show") }}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{ $t("survey.surveyattendee.entries") }}</label>
          </b-col>
          <!-- Search -->
          <b-col cols="12" md="3">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1"
                :placeholder="$t('survey.surveyattendee.search_placeholder')" />
            </div>
          </b-col>
          <!-- Search -->
          <b-col cols="8" md="5">
            <b-row :key="currentId">
              <b-col cols="8">
                <member-picker :searchOptions="searchOptions" @selectionChanged="selectionChanged">
                </member-picker>
              </b-col>
              <b-col cols="3">
                <b-button :variant="canAddnewAttender ? 'primary' : 'secondary'"
                  @click="canAddnewAttender ? addSelectedMemberToSurvey : null">
                  <span class="text-nowrap">{{
                    $t("survey.surveyattendee.add_to_survey")
                  }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <b-table ref="refUserListTable" class="position-relative" :items="fetchCourses" responsive :fields="tableColumns"
        primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('survey.surveyattendee.no_matching_records')"
        :sort-desc.sync="isSortDirDesc">
        <template #head()="data">
          <span class="text">{{ $t(data.label) }}</span>
        </template>
        <template #cell(attendeeEquality)="data">
          <span> {{ $t(resolvePosition(data.item.attendeeEquality)) }}</span>
        </template>
        <template #cell(surveyStatus)="data">
          <b-badge pill :variant="`${resolveSurveyStatusVariant(data.item.status)}`" class="text-capitalize">
            {{ $t(resolveSurveyStatus(data.item.status)) }}
          </b-badge>
        </template>

        <template #cell(surveyLink)="data">
          <b-badge variant="light-secondary" v-if="Boolean(data.item.deleted)">
            {{ $t("survey.surveyattendee.deleted") }}
          </b-badge>
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="flat-info" v-if="!Boolean(data.item.deleted)"
            @click="withHtml(data.item)">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">{{
              $t("survey.surveyattendee.show_survey_url")
            }}</span>
          </b-button>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t("Showing") }} {{ dataMeta.from }} {{ $t("to") }}
              {{ dataMeta.to }} {{ $t("of") }}
              {{ dataMeta.of }}
              {{ $t("entries") }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { avatarText } from "@core/utils/filter";
import UsersListFilters from "./SurveyattendeeListFilters.vue";
import useUsersList from "./useSurveyattendeeList";
import userStoreModule from "../surveyattendeeStoreModule";
import UserListAddNew from "./SurveyattendeeListAddNew.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import MemberPicker from "@/views/members/component/MemberPicker.vue";

export default {
  created() {
    this.itemtitle = this.$route.query.t;
  },
  computed: {
    canAddnewAttender() {
      return this.rateallSubjects.length > 0;
    },
  },
  data() {
    return {
      itemtitle: "",
      required,
      alphaNum,
      loading: false,
      currentId: 0,
      rateHigherPositions: false,
      rateLowerPositions: true,
      rateSamePositions: true,
      searchOptions: null,
      surveyitemid: null,
      searchType: null,
      groupSubject: null,
      branchSubject: null,
      departmentSubject: null,
      positionSubject: null,
      rateallSubjects: [],
      clientDomainMapping: {
        'cb6ce355-7dd8-4ba8-ae8a-c57371b2ac1a': 'https://sp.niso.dev/',
        'b6002600-1a34-40b4-bfbb-b5f8592900ca': 'https://sp.niso.dev/br',
        '2cd9e5f3-238d-49f2-a7f9-ab0c354e54d6': 'https://sp.niso.dev/tr',
        'default': 'https://sp.niso.dev/tr',
      },
    };
  },
  methods: {
    getClientDomain(clientGuid) {
      return this.clientDomainMapping[clientGuid] || this.clientDomainMapping['default'];
    },
    withHtml(attendee) {
      // "https://sp.niso.dev/?c=" +
      const baseDomain = this.getClientDomain(attendee.clientguid);
      const url = `${baseDomain}?c=${attendee.clientguid}&a=${attendee.invitecode}`;
      console.log(url);

      this.$swal({
        title: '<span class="font-weight-bolder">Survey URL </span>',
        icon: "info",
        html:
          "<br>You can access survey from:<br>" +
          '<a href="' +
          url +
          '" target="_blank" rel="noopener noreferrer" style="color:blue; font-size:18px; font-weight:bold;"><br>Survey Link</a>',
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonAriaLabel: "Thumbs down",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });
    },
    newRecordCreated(coursemode) {
      this.currentId++;
    },
    selectionChanged(payload) {
      //console.log(payload);
      //   this.localOptions.rateSubject=payload;
      if (payload == null) {
        this.rateallSubjects = [];
      } else {
        this.rateallSubjects = [];
        this.rateallSubjects.push(payload);
      }
    },

    addSelectedMemberToSurvey() {
      //console.log("Attendee added" );
      this.loading = true;

      this.surveyitemid = router.currentRoute.query.s;

      store
        .dispatch("app-surveys/addAttendeeToSubject", this.rateallSubjects[0])
        .then((response) => {
          var result = response.data.success;
          if (result != null && result != undefined && result == 100) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `Success`,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            this.isLoading = false;
            this.isUpdated = false;
            this.rateallSubjects = [];
            this.loading = false;
            this.newRecordCreated();

            this.refetchData();
          } else {
            //console.log(response);

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `Error`,
                text: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
            this.isLoading = false;
            this.isUpdated = false;
          }
        });
    },

    getRoute(coursemode) {
      return "page-coursemode";
    },
    deleteExam(coursedata) {
      //console.log(coursedata);

      store
        .dispatch("app-surveys/deleteAttende", coursedata)
        .then((response) => {
          var result = response.data.success;

          coursedata.deleted = true;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          this.isLoading = false;
          this.isUpdated = false;
        });
    },
  },

  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    MemberPicker,
    vSelect,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-surveys";
    //console.log("surveys");

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const isAddNewUserSidebarActive = ref(false);

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const getPageroute = (surveyid) => {
      var result = { name: "survey-questions", params: { id: surveyid } };

      return result;
    };
    const getStatus = (status) => {
      // DRAFT
      if (status == "0") return "secondary";
      // published
      if (status == "100") return "success";

      // ended by time limit
      if (status == "200") return "warning";
      // stopped
      if (status == "500") return "warning";

      return "secondary";
    };
    const getStatusText = (status) => {
      // DRAFT
      if (status == "0") return "Draft";
      // published
      if (status == "100") return "Published";

      // ended by time limit
      if (status == "200") return "Ended";
      // stopped
      if (status == "500") return "Stopped";

      return "Draft";
    };

    const planOptions = [
      { label: "Basic", value: "basic" },
      { label: "Company", value: "company" },
      { label: "Enterprise", value: "enterprise" },
      { label: "Team", value: "team" },
    ];

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const {
      surveyInfo,
      fetchCourses,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolvePosition,
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVariantText,
      resolveSurveyStatusVariant,
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      resolveCourseContent,
      resolveSurveyStatus,
    } = useUsersList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,
      surveyInfo,
      fetchCourses,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolvePosition,
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVariantText,
      resolveSurveyStatus,
      resolveSurveyStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      resolveCourseContent,
      getPageroute,
      getStatus,
      getStatusText,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
